export const LOAD_RECOMMENDATIONS = 'recommendations/LOAD_RECOMMENDATIONS';
